import * as Sentry from '@sentry/react';

import { LocalRetailerConfiguration } from '../app-config.types';

export const isValidLocalRetailerConfiguration = (config: unknown): config is LocalRetailerConfiguration => {
  if (!config || typeof config !== 'object') {
    Sentry.captureException(new Error(`${config}: configuration is empty or not an object.`));
    return false;
  }

  // Object.hasOwn is not properly polyfilled
  // eslint-disable-next-line no-prototype-builtins
  if (config?.hasOwnProperty('version')) {
    // there is no type narrowing for hasOwn
    // @ts-ignore
    if (config.version === 2) {
      return true;
    }
  }

  Sentry.captureException(new Error(`${config}: unable to parse configuration. Version mismatch.`));
  return false;
};
